import { createRefPath_client } from "../../firestoreData/appData/appRefPaths";
import { createFsDocKey } from "../../firestoreData/appData/fsAppData";
import { grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";

export const rts = {
  handleInit_demo: 'handleInit_demo',
  handleCreate_demo: 'handleCreate_demo',
  handleSet_updating: 'handleSet_updating',
  handleSet_showPreview: 'handleSet_showPreview',
  handleSet_demoOn: 'handleSet_demoOn',
  handleResetDemo: 'handleResetDemo',
  ...grts
}

export const demoInitialState = (initState) => {
  return { ...initState, demoOn: false }
};

export const demoReducer = (state, action) => {

  const { database_fns } = state
  const { type } = action

  switch (type) {
    case rts.handleInit_demo:
      const demoPreview = action.googleSheetsPreview
      const { projectData, projectSettings: demoSettings } = action.googleSheetsPreview ?? {}
      const _name = projectData?.eventData?.name
      const _currentDemo = {
        projectData,
        demoSettings
      }
      return { ...state, demoPreview, currentName: _name, currentDemo: _currentDemo, showPreview: true }

    case rts.handleCreate_demo:
      createDemo(database_fns)
      return state

    case rts.handleSet_updating:
      return { ...state, updating: action.updating }

    case rts.handleSet_showPreview:
      return { ...state, showPreview: action.showPreview }

    case rts.handleSet_demoOn:
      return { ...state, demoOn: action.demoOn }

    case rts.handleResetDemo:
      return { ...state, demoOn: false, demoPreview: null, currentDemo: null, showPreview: false, currentName: 'Preview' }

    case rts.handleStartUpdate:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
    case rts.updateError:
    case rts.handleStopUpdate:
      return responseReducers(state, action, { questionProps: null })

    default:
      return { ...state }
  }
}

export const demoHandlers = (dispatch) => {
  return {
    handleCreate_demo: (googleSheetsPreview) => { dispatch({ type: rts.handleCreate_demo, dispatch, googleSheetsPreview }) },
    handleInit_demo: (googleSheetsPreview) => { dispatch({ type: rts.handleInit_demo, dispatch, googleSheetsPreview }) },
    handleSet_updating: (updating) => { dispatch({ type: rts.handleSet_updating, dispatch, updating }) },
    handleSet_showPreview: (showPreview) => { dispatch({ type: rts.handleSet_showPreview, dispatch, showPreview }) },
    handleSet_demoOn: (demoOn) => { dispatch({ type: rts.handleSet_demoOn, dispatch, demoOn }) },
    handleResetDemo: () => { dispatch({ type: rts.handleResetDemo, dispatch }) },
    ...responseHandlers(dispatch)
  }
}

const createDemo = async (database_fns) => {
  const key_event = database_fns.get_docKey()
  const refPath_event = createRefPath_client(_pathViews, ['events', key_event])
  const refPath_settings = createRefPath_client(_pathViews, ['settings', database_fns.get_docKey()])
  const dataToUpdate = {
    name: currentName
  }
  console.log('refPath_event', refPath_event)
  console.log('refPath_settings', refPath_settings)
  console.log('dataToUpdate', dataToUpdate)
  // await database_fns.set_doc(refPath_event, dataToUpdate)
}